import React from 'react'
import { RadioButtonLabel, CustomRadio, HiddenRadio } from './RadioButton.styles'

export interface RadioButtonProps {
  name: string
  value: string
  checked: boolean
  onChange: (value: string) => void
  outlineColor?: string
  outlineWidth?: number
  centerColor?: string
  size?: number
  onClick?: (e: React.MouseEvent) => void
}

const RadioButton: React.FC<RadioButtonProps> = ({
  name,
  value,
  checked,
  onChange,
  outlineColor,
  outlineWidth,
  centerColor,
  size,
  onClick
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick(e)
    } else {
      e.stopPropagation()
    }
  }

  return (
    <RadioButtonLabel onClick={handleClick}>
      <HiddenRadio
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
      />
      <CustomRadio
        $outlineColor={outlineColor}
        $outlineWidth={outlineWidth}
        $centerColor={centerColor}
        $size={size}
      />
    </RadioButtonLabel>
  )
}

export default RadioButton
